<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Lista ustawień</v-flex>

        <v-spacer />

        <v-flex>
          <search />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-tabs v-model="activeTab">
            <v-tab v-for="group in settingGroup" :key="group.name" exact :to="route(group)">{{ group.name }}</v-tab>

            <v-layout text-xs-right>
              <v-flex>
                <check-permission permissions="SETTING.ADD">
                  <v-btn large color="error" @click="showAddModal">DODAJ USTAWIENIE</v-btn>
                </check-permission>
              </v-flex>
            </v-layout>
          </v-tabs>

          <div class="mt-2">
            <material-table
              entity-type="setting"
              :headers="headers"
              :actions="actions"
              :items="list"
              :total-count="count"
              @edit="showEditModal($event.id)"
              @delete="showDeleteDialog($event.id)"
            />

            <material-dialog
              title="Potwierdź usunięcie"
              text="Czy na pewno chcesz usunąć ustawienie?"
              :show="!!idToDelete"
              :id="idToDelete"
              @close="hideDeleteDialog"
              @confirm="remove"
            />
          </div>
        </v-flex>
      </v-layout>
    </material-card>

    <modal :show="showModal" :id="idToEdit" :edit="!!idToEdit" @close="hideModal" @save="add" @update="updateSetting" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Search from '@/components/material/table/Search';
import { listMixin } from '@/mixins/list';
import store from '@/store/store';
import { DELETE_ACTION, EDIT_ACTION } from '@/utils/actions';
import Modal from './modals/Add.modal';

// @vuese
// Wyświetlanie listy ustawień
// @group Settings
export default {
  components: {
    MaterialCard,
    MaterialTable,
    MaterialDialog,
    Modal,
    Search
  },
  mixins: [
    listMixin('settings', {
      added: 'Dodano ustawienie.',
      addError: 'Nie udało się dodać ustawienia.',
      updated: 'Zaktualizowano ustawienie.',
      updateError: 'Nie udało się zaktualizować ustawienia.',
      deleted: 'Usunięto ustawienie.',
      deleteError: 'Nie udało się usunąć ustawienia.',
      listError: 'Nie udało się pobrać listy ustawień.'
    })
  ],
  data() {
    return {
      headers: [
        { text: 'Kod ustawienia', value: 'code', orderBy: 'code' },
        { text: 'Opis ustawienia', value: 'description', orderBy: 'description' }
      ],
      actions: [DELETE_ACTION, EDIT_ACTION],
      activeTab: this.$route.path
    };
  },
  methods: {
    // @vuese
    // Filtry
    filters(pagination) {
      const groupId = this.$router.currentRoute.params.id && parseInt(this.$router.currentRoute.params.id);
      return { ...pagination, groupId, noGroup: !groupId || undefined };
    },
    // @vuese
    // Aktualizuje ustawienie
    updateSetting(data) {
      this.update(data).then(() => this.reloadList(this.$route));
    },
    // @vuese
    // Routing zakładki
    route(group) {
      return { path: group.route, query: { ...this.$route.query, page: 1 } };
    }
  },
  computed: {
    ...mapState({
      groups: state => state.settingGroups.list
    }),
    settingGroup() {
      const displayGroups = this.groups.map(group => ({
        route: `/settings/${group.id}`,
        name: group.name
      }));

      displayGroups.push({
        route: '/settings',
        name: 'Ogólne'
      });

      return displayGroups;
    }
  }
};
</script>
